
const initialState = {
    digitalAssets: null,
    digitalFootPrint: null,
    findings: null,
    brandInsight: null,
    infrastructure: null,
    organizationHackerScore: null,
    domainHackerScore: null,
    landscapeChartValue: null,
    countryStats: null,
    darkWebStats: null,
    vulnerableSubdomain: null,
    vulnerableIpaddress: null,
    vulnerableCategory: null,
    vulnearbilityStats: null,
    becStats: null,
    sslExpiryData: null,
    domainRiskScore: null,
    domainRiskScoreOverview: null
}

export default function dashboardReducer(state=initialState, action) {
    switch(action.type) {
        case 'DIGITAL_ASSET_STATS_SUCCESS' :
            return {
                ...state,
                digitalAssets: action.payload
            }
        case 'DIGITAL_FOOT_PRINT_STATS_SUCCESS':
            return {
                ...state,
                digitalFootPrint: action.payload
            }
        case 'FINDINGS_STATS_SUCCESS':
            return {
                ...state,
                findings: action.payload
            }
        case 'BRAND_INSIGHT_STATS_SUCCESS':
            return {
                ...state,
                brandInsight: action.payload
            }
        case 'INFRASTRUCTURE_STATS_SUCCESS' :
            return {
                ...state,
                infrastructure: action.payload
            }
        case 'ORGANIZATION_HACKER_STATS_SUCCESS':
            return {
                ...state,
                organizationHackerScore: action.payload
            }
        case 'DOMAIN_HACKER_STATS_SUCCESS':            
            return {
                ...state,
                domainHackerScore: action.payload
            }
        case 'LANDSCAPE_STATS_SUCCESS':
            return {
                ...state,
                landscapeChartValue: action.payload
            }
        case 'COUNTRY_STATS_SUCCESS':
            return {
                ...state,
                countryStats: action.payload
            }
        case 'DARK_WEB_STATS_SUCCESS':
            return {
                ...state,
                darkWebStats: action.payload
            }
        case 'VULNERABLE_SUBDOMAIN_STATS_SUCCESS':
            return {
                ...state,
                vulnerableSubdomain: action.payload
            }
        case 'VULNERABLE_IP_ADDRESS_STATS_SUCCESS':
            return {
                ...state,
                vulnerableIpaddress: action.payload
            }
        case 'VULNERABLE_CATEGORY_STATS_SUCCESS':
            return {
                ...state,
                vulnerableCategory: action.payload
            }
        case 'VULNERABILITY_STATS_SUCCESS':
            return {
                ...state,
                vulnearbilityStats: action.payload
            }
        case 'BEC_STATS_SUCCESS':
            return {
                ...state,
                becStats: action.payload
            }
        case 'SSL_EXPIRY_STATS_SUCCESS':
            return {
                ...state,
                sslExpiryData: action.payload
            }
        case 'DOMAIN_RISK_SCORE_SUCCESS':
            return {
                ...state,
                domainRiskScore: action.payload
            }
        case 'DOMAIN_RISK_SCORE_OVERVIEW_SUCCESS':
            return {
                ...state,
                domainRiskScoreOverview: action.payload
            }
        default:
            return state;
    }
}